import { decrypt } from 'src/utils/storage'

import HRIcon from 'src/assets/icons/menu/hr.svg?react'
import LabIcon from 'src/assets/icons/menu/lab.svg?react'
import HomeIcon from 'src/assets/icons/menu/home.svg?react'
import TechIcon from 'src/assets/icons/menu/tech.svg?react'
import SupplyIcon from 'src/assets/icons/menu/supply.svg?react'
import PricesIcon from 'src/assets/icons/menu/prices.svg?react'
import MasterDataIcon from 'src/assets/icons/menu/hdd.svg?react'
import FinanceIcon from 'src/assets/icons/menu/finance.svg?react'
import ExtraNetIcon from 'src/assets/icons/menu/extra-net.svg?react'
import LogisticsIcon from 'src/assets/icons/menu/logistics.svg?react'
import MarketingIcon from 'src/assets/icons/menu/marketing.svg?react'
import ReportingIcon from 'src/assets/icons/menu/management.svg?react'
import ProductionIcon from 'src/assets/icons/menu/production.svg?react'
import CommercialIcon from 'src/assets/icons/menu/commercial.svg?react'
import ToolsIcon from 'src/assets/icons/menu/tools.svg?react'
import OrdersIcon from 'src/assets/icons/menu/orders.svg?react'
import PriceIcon from 'src/assets/icons/menu/pricing.svg?react'

export const menuIcons = {
  lab: LabIcon,
  home: HomeIcon,
  it: TechIcon,
  prices: PricesIcon,
  supply: SupplyIcon,
  financial: FinanceIcon,
  reporting: ReportingIcon,
  logistics: LogisticsIcon,
  'extra-net': ExtraNetIcon,
  'human-resources': HRIcon,
  commercial: CommercialIcon,
  production: ProductionIcon,
  MarketingIcon: MarketingIcon,
  master_data: MasterDataIcon,
  tools: ToolsIcon,
  orders: OrdersIcon,
  pricing: PriceIcon,
}

const userStorage = localStorage.getItem('user-storage')
const user = userStorage ? JSON.parse(decrypt(userStorage)) : null

const userCompany = user?.state?.user?.CompanyId

export const menuPaths = {
  dashboard: '/dashboard',
  'home-workflow-types': userCompany
    ? `/workflows/types?company_ids=${userCompany}`
    : '/workflows/types',
  'home-workflow-groups': '/workflows/groups',
  'home-workflow-documents': '/workflows',
  'home-access_control-user': '/users',
  'commercial-case-case_management': '/case-management',
  'commercial-case-sla': '/case-management/sla',
  'commercial-case-business': '/case-management/office-hours',
  'commercial-claims-global_claim': '/claim',
  'commercial-partner-business_partner_business_partner': '/business-partner',
  'commercial-partner-business_partner_automotive_discount':
    '/business-partner/automotive-discount',
  'commercial-partner-business_partner_bulk_update':
    '/business-partner/mass-update',
  'pricing-automotive-automotive_table_configuration': '/price/automotive',
  'pricing-industrial-industrial_table_configuration': '/price/industrial',
  'pricing-automotive-automotive_placement_configuration':
    '/price/automotive/positioning',
  'pricing-automotive-automotive_settings_up_exceptions_or_discounts':
    '/price/automotive/discount-exception',
  'pricing-industrial-industrial_position_configuration':
    '/price/industrial/positioning-cube',
  'pricing-industrial-industrial_group_configuration':
    '/price/industrial/group',
  'pricing-others-others_material_exception_by_channel':
    '/price/material-exception-by-channel',
  'pricing-others-others_import':
    '/price/import',
  'commercial-sales_order-my_orders': '/my-orders',
  'commercial-sales_order-sap_sales_order': '/sap-sales-order',
  'commercial-contract-contract_list': '/contracts',
  'commercial-sales-contract_report': '/contracts-report',
  'financial-open_invoices-open_invoices_region': '/invoices-region',
  'financial-invoices-open_invoices_grouped': userCompany
    ? `/open-invoices-grouped?companyId=${userCompany}`
    : '/open-invoices-grouped',
  'financial-open_invoices-open_invoices_sales_representative':
    '/invoices-sales-representative',
  'financial-invoicesopen_invoices': userCompany
    ? `/open-invoices?companyIds=${userCompany}`
    : '/open-invoices',
  'financial-material_cost': '/material-cost',
  'reporting-reporting_tool': '/reporting',
  'home-access_control': '/access-control',
  'financial-cost-managerial': userCompany
    ? `/managerial-cost?company_id=${userCompany}`
    : '/managerial-cost',
  'financial-cost-accounting': '/cost-accounting',
  sales: '/sales-report',
  'bi-report': '/reporting-tool',
  'it-import-import_infocenter': '/import-infocentre',
  'commercial-sales-report_682': '/sales-report-682',
  'commercial-sales-682_report': '/sales-report-682',
  'commercial-sales-broke_comission_report': '/broker-commission',
  'commercial-sales-bi_report': '/reporting-tool',
  'commercial-sales-sales_perfomance_report': '/sales-performance-report',
  'commercial-sales-reports': '/reports',
  'commercial-sales-reports-682': '/reports-682',
  'commercial-sales-reports-682-hana': '/reports-682-hana',
  'commercial-sales-reports-682-europe': '/reports-682-europe',
  'master_data-business_partner-account_group': '/crud-account-group',
  'master_data-business_partner-business_partner_role':
    '/crud-business-partner-role',
  'master_data-business_partner-channel': '/crud-channel',
  'master_data-business_partner-customer_tiering_tier':
    '/crud-customer-tiering-tier',
  'master_data-business_partner-distribution_channel':
    '/crud-distribution-channel',
  'master_data-business_partner-sales_area': '/crud-sales-area',
  'master_data-business_partner-sales_district': '/crud-sales-district',
  'master_data-business_partner-sales_group': '/crud-sales-group',
  'master_data-business_partner-sales_office': '/crud-sales-office',
  'master_data-business_partner-sales_organization': '/crud-sales-organization',
  'master_data-material-deposit': '/crud-deposit',
  'master_data-material-material_hierarchy_first_level':
    '/crud-material-hierarchy-first-level',
  'master_data-material-material_hierarchy_second_level':
    '/crud-material-hierarchy-second-level',
  'master_data-material-material_hierarchy_third_level':
    '/crud-material-hierarchy-third-level',
  'master_data-material-material_hierarchy_fourth_level':
    '/crud-material-hierarchy-fourth-level',
  'master_data-material-material_hierarchy_fifth_level':
    '/crud-material-hierarchy-fifth-level',
  'master_data-material-material_hierarchy_sixth_level':
    '/crud-material-hierarchy-sixth-level',
  'master_data-material-material_hierarchy_seventh_level':
    '/crud-material-hierarchy-seventh-level',
  'master_data-material-material_simp': '/crud-material-simp',
  'master_data-material-material_type': '/crud-material-type',
  'master_data-material-tier': '/crud-tier',
  'financial-credit_limit-request': '/credit-limit',
  'tools-reports-purchase_orders': '/tools-reports/purchase-orders',
  'tools-reports-open_invoices': '/tools-reports/open-invoices',
  'orders-my_purchase_orders-b2b_hyundai': '/orders/b2b-hyundai/create',
  'orders-my_purchase_orders-b2b_europe': '/orders/b2b-europe/create',
  'orders-my_purchase_orders-b2b_india': '/orders/b2b-india/create',
  'orders-my_purchase_orders-b2b_asia': '/orders/b2b-asia/create',
  'orders-my_purchase_orders-b2b_argentina': '/orders/b2b-argentina/create',
  'commercial-sales_order-hana': '/create-europe-hana',
  'commercial-sales_order-china': '/internal-china/create',
  'commercial-sales_order-india': '/internal-india/create',
  'commercial-sales_order-brazil': '/internal-brazil/create',
  'commercial-sales_order-argentina': '/internal-argentina/create',
  'orders-my_purchase_orders-purchase_orders': '/orders/my-purchase-orders',
}

export const primaryMenus = [
  {
    name: 'home',
    paths: ['/workflows/types', '/workflows/groups', '/workflows', '/users'],
  },
  {
    name: 'commercial',
    paths: [
      '/sales-report',
      '/sales-report-682',
      '/broker-commission',
      '/sales-performance-report',
    ],
  },
  {
    name: 'financial',
    paths: [
      '/invoices-region',
      '/open-invoices-grouped',
      '/invoices-sales-representative',
      '/open-invoices',
      '/material-cost',
      '/managerial-cost',
      '/cost-accounting',
    ],
  },
  { name: 'reporting', paths: ['/reporting-tool'] },
  {
    name: 'master_data',
    paths: [
      '/crud-account-group',
      '/crud-business-partner-role',
      '/crud-channel',
      '/crud-customer-tiering-tier',
      '/crud-distribution-channel',
      '/crud-sales-area',
      '/crud-sales-district',
      '/crud-sales-group',
      '/crud-sales-office',
      '/crud-sales-organization',
      '/crud-deposit',
      '/crud-material-hierarchy-first-level',
      '/crud-material-hierarchy-second-level',
      '/crud-material-hierarchy-third-level',
      '/crud-material-hierarchy-fourth-level',
      '/crud-material-hierarchy-fifth-level',
      '/crud-material-hierarchy-sixth-level',
      '/crud-material-hierarchy-seventh-level',
      '/crud-material-simp',
      '/crud-material-type',
      '/crud-tier',
    ],
  },
  {
    name: 'tools-reports',
    paths: ['/tools-reports/purchase-orders'],
  },
]
